import { Flex, Stack } from "@chakra-ui/react";
import { AboutUs, Footer, HeroCarousel, LogoAndSocials, PlatformStats, PopularGames } from "./components";
import { HeroCarouselSlideProps } from "./components/HeroCarousel/components/HeroCarouselSlide";
import { PopularGameCardProps } from "./components/PopularGameCard";
import { RecentWins } from "./components/RecentWins";

const heroSlides: HeroCarouselSlideProps[] = [
  {
    title: "Be the House.",
    description:
      "Supply ETH and YOLO liquidity to the single-player games to grow your position and earn additional rewards!",
    href: "/liquidity",
    imageSrc: "/banner/be-the-house.png",
    blurImageSrc: "/banner/be-the-house-blur.png",
  },
];

const homeGameCards: PopularGameCardProps[] = [
  {
    title: "LaserBlast",
    description: "Invaders must die.",
    href: "/laser-blast",
    gameId: "laserblast",
    imageSrc: "/game-cards/laserblast.png",
    blurImageSrc: "/game-cards/laserblast-blur.png",
  },
  {
    title: "YOLO",
    description: "Deposit crypto and spin the wheel. But remember: there can be only one winner.",
    href: "/yolo/blast",
    gameId: "yolo",
    imageSrc: "/game-cards/yolo.png",
    blurImageSrc: "/game-cards/yolo-blur.png",
  },
  {
    title: "MOON or DOOM",
    description:
      "Think you know where crypto prices are headed in the next 60 seconds? Put your money where your mouth is.",
    href: "/moon-or-doom",
    gameId: "mod",
    imageSrc: "/game-cards/mod.png",
    blurImageSrc: "/game-cards/mod-blur.png",
  },
];

export const HomeView = () => {
  return (
    <Flex flexDirection="column" alignItems="center" width="100%" maxWidth="1600px" mx="auto">
      <Stack spacing={{ base: 9, lg: 12 }} py={{ base: 12, lg: 16 }} width="100%">
        <HeroCarousel slides={heroSlides} />
        <LogoAndSocials />
        <PopularGames cards={homeGameCards} />
        <PlatformStats />
        <RecentWins />
        <AboutUs />
      </Stack>
      <Footer />
    </Flex>
  );
};
